import {Injectable} from "@angular/core";
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {FilterParams} from "app/models/filter_form.model";
import {BaseService} from "app/views/base.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import { IStatResult } from "../../models/responce_result.model";
import { DataProvider2 } from "../../provider/data2.provider";
import { Site } from "../../models/support.model";

interface IAccessorSiteInfo {
	stats: object[];
	siteInfo: Site;
}

@Injectable()
export class AccessorService extends BaseService {
	constructor(
		public http: HttpClient,
		public filter: FilterFormService,
		public dp: DataProvider2,
	) {
		super(http);
	}
	
	
	getIframeInfo(): Observable<Object> {
		return this.dp.get('/accessor2/iframe', this.filter.filterParams);
	}
	
	
	getMainInfo(queryParams: FilterParams): Observable<Object> {
		return this.dp.get('/accessor2/main', queryParams);
	}
	
	
	getStats(queryParams: any): Observable<IStatResult> {
		return this.dp.get('/accessor2/stats', queryParams);
	}
	
	
	getMyStats(queryParams: any): Observable<IStatResult> {
		return this.dp.get('/accessor2/mystats', queryParams);
	}
	
	
	getPersonalStats(queryParams: any): Observable<IStatResult> {
		return this.dp.get('/accessor2/personal_stats', queryParams);
	}
	
	
	setCategory(data: any): Observable<Object> {
		return this.dp.get('/accessor2/set', data);
	}
	
	
	checkSite(data: any): Observable<Object> {
		return this.dp.get('/accessor2/check', data);
	}
	
	
	updateSite(data: any): Observable<Object> {
		return this.dp.get('/accessor2/update', data);
	}
	
	
	getConfig() {
		return this.dp.get('/accessor2/manage');
	}
	
	
	saveConfig(data: object) {
		return this.dp.get('/accessor2/dump_params', data);
	}
	
	
	getSiteDetails(queryParams: any): Observable<IAccessorSiteInfo> {
		return this.dp.get<IAccessorSiteInfo>('/accessor2/site_details', queryParams);
	}
}
